var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99968 2.16602C7.69849 2.16602 5.83301 4.0315 5.83301 6.33268C5.83301 8.63387 7.69849 10.4993 9.99968 10.4993C12.3009 10.4993 14.1663 8.63387 14.1663 6.33268C14.1663 4.0315 12.3009 2.16602 9.99968 2.16602ZM7.49968 6.33268C7.49968 4.95197 8.61896 3.83268 9.99968 3.83268C11.3804 3.83268 12.4997 4.95197 12.4997 6.33268C12.4997 7.71339 11.3804 8.83268 9.99968 8.83268C8.61896 8.83268 7.49968 7.71339 7.49968 6.33268Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 19.666C8.71592 19.666 6.85786 19.3745 5.46253 18.7638C4.77753 18.464 4.08088 18.035 3.67614 17.4139C3.46327 17.0872 3.3287 16.7024 3.33311 16.2729C3.33748 15.8472 3.47754 15.4394 3.71294 15.06C4.8541 13.2207 7.18867 11.3327 9.99967 11.3327C12.8107 11.3327 15.1452 13.2207 16.2864 15.06C16.5218 15.4394 16.6619 15.8472 16.6662 16.2729C16.6706 16.7024 16.5361 17.0872 16.3232 17.4139C15.9185 18.035 15.2218 18.464 14.5368 18.7638C13.1415 19.3745 11.2834 19.666 9.99967 19.666ZM5.12917 15.9387C5.01944 16.1155 5.00032 16.2291 4.99969 16.29C4.99911 16.3469 5.01373 16.4138 5.07248 16.5039C5.21096 16.7164 5.54723 16.9816 6.13078 17.237C7.27254 17.7367 8.89404 17.9993 9.99967 17.9993C11.1053 17.9993 12.7268 17.7367 13.8686 17.237C14.4521 16.9816 14.7884 16.7164 14.9269 16.5039C14.9856 16.4138 15.0002 16.3469 14.9997 16.29C14.999 16.2291 14.9799 16.1155 14.8702 15.9387C13.9351 14.4315 12.07 12.9993 9.99967 12.9993C7.92939 12.9993 6.06429 14.4315 5.12917 15.9387Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIcon);
export default __webpack_public_path__ + "static/media/humanIcon.5c48ce72e9c3d515b89a666df90adcc5.svg";
export { ForwardRef as ReactComponent };